import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md",
  style: {"height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_q_page_container = _resolveComponent("q-page-container")
  const _component_q_layout = _resolveComponent("q-layout")

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "lHh Lpr lFf",
    style: {"height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}